.rightPaneContainer {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .drawerBorder {
    cursor: col-resize;
    position: absolute;
    top: 0;
    left: -12px;
    height: 100%;
    width: 12px;
  }
}
